import { useEffect, useState } from "react";
import { ClipboardText } from "@phosphor-icons/react";
import api from "../lib/api";

export default function MissingShiftNotesCard() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState("");

  useEffect(() => {
    api.get("/shift-notes/missing").then((r) => setRows(r.data.employees || [])).catch(() => setRows([]));
  }, []);

  if (!rows) return null;

  return (
    <div className="mb-6 rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-testid="missing-shift-notes-card">
      <div className="flex items-center gap-2">
        <ClipboardText size={18} className="text-primary" />
        <p className="font-heading text-sm font-semibold text-stone-900">Shift wrap-up notes — missing</p>
      </div>
      {rows.length === 0 ? (
        <p className="mt-2 text-sm text-stone-500" data-testid="missing-notes-empty">Every worked visit in the last 14 days has a wrap-up note.</p>
      ) : (
        <>
          <p className="mt-1 text-xs text-stone-500">Worked visits with no wrap-up note yet. Red means the oldest is 3+ days — time to follow up.</p>
          <div className="mt-3 space-y-2">
            {rows.map((e) => (
              <div key={e.user_id} className={`rounded-lg border px-4 py-2.5 ${e.escalate ? "border-[#C0392B]/40 bg-[#C0392B]/5" : "border-stone-200"}`} data-testid={`missing-notes-${e.user_id}`}>
                <button type="button" onClick={() => setOpen(open === e.user_id ? "" : e.user_id)} className="flex w-full items-center justify-between text-left" data-testid={`missing-notes-toggle-${e.user_id}`}>
                  <p className="text-sm font-medium text-stone-900">{e.employee_name}</p>
                  <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${e.escalate ? "bg-[#C0392B] text-white" : "bg-stone-200 text-stone-700"}`}>
                    {e.count} missing{e.escalate ? ` · oldest ${e.max_days_old}d` : ""}
                  </span>
                </button>
                {open === e.user_id && (
                  <div className="mt-2 space-y-1 border-t border-stone-100 pt-2">
                    {e.missing.map((m) => (
                      <p key={`${m.visit_ref}-${m.shift_date}`} className="text-xs text-stone-600" data-testid={`missing-notes-row-${m.visit_ref}`}>
                        {m.shift_date} — {m.client_name} <span className="text-stone-400">({m.days_old}d ago)</span>
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
